module.exports = __webpack_public_path__ + "img/coen-van-der-voort.31ad9d64.jpg";